import { SIZES } from 'common/constants/sizes';
import styled from 'styled-components';

export const StyledInvalidEmptyStateImg = styled.img`
  margin-left: 3rem;
`;

export const StyledHeader = styled.div`
  font-size: ${SIZES['x-x-large']};
  margin-bottom: 0.5rem;
`;

export const StyledDescription = styled.div`
  font-size: ${SIZES['x-medium']};
`;

export const StyledInvalidFilterSet = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
